/**
 * author: Soumya Shreyas
 */
import React, { useContext, useEffect, useState } from "react";
import { withTranslation } from "react-i18next";
import { BiUser } from "react-icons/bi";
import { BsFileEarmark } from "react-icons/bs";
import { Link } from "react-router-dom";

import moment from "moment";
import "react-datepicker/dist/react-datepicker.css";
import "./AlertBox.scss";

import {
  Badge
} from "react-bootstrap";
import { RegulationContext } from "../../../App";
import { RISKSTATUS } from "../../../core/constants/common";
import CompanyDashboardService from "../../../core/service/CompanyDashboardService";
import Utils from "../../../core/utilities/Utils";
import TaskModal from "../TaskModal/TaskModal";

const AlertBox = ({ t, profileId = "" }) => {
  const [modalDisplay, setModalDisplay] = useState(false);
  const [editAlert, setEditAlert] = useState("");
  const [alerts, setAlerts] = useState([]);  
  const [totalAlerts, setTotalALerts] = useState("");
  var lsDat = JSON.parse(localStorage.getItem("authority"));
  const { glbRegulation, setGlbRegulation } = useContext(RegulationContext);
  const glbRegulationId = glbRegulation?.id ? glbRegulation.id : "";
  const glbRegulationCode = glbRegulation?.code ? glbRegulation.code : "";
  let encodedDat = "";

  if (profileId) {
    let obj = {
      type: "SUPPLIER_ADMIN",
      id: profileId,
    };
    encodedDat = Utils.encodeBase64(JSON.stringify(obj));
  } else {
    let obj = {
      type: "SUBSCRIBER_ADMIN",
      id: 0,
    };
    encodedDat = Utils.encodeBase64(JSON.stringify(obj));
  }

  useEffect(() => {
    listAlerts();
  }, [glbRegulationId]);

  const handleTaskSave = () => { 
    setModalDisplay(false);
    listAlerts();
  };

  const handleClick = (item) => {
    setEditAlert(item);
    setModalDisplay(true);
  };
  const listAlerts = () => {
    if (profileId) {
      let companyId = lsDat.profile.company.id;
      var string = Utils.generateUrlParamCompanyRegulationWithSupplier(
        companyId,
        glbRegulationId,
        profileId
      );
      var encodedParam = Utils.encodeBase64(string);
      CompanyDashboardService.listSupplierAlerts(encodedParam, glbRegulationCode)
        .then((response) => {
          let count = parseFloat(response.headers["x-total-count"]);
          setTotalALerts(count);
          setAlerts([...response.data]);
        })
        .catch((error) => {
          //ErrorHandlingService.handleError(error.response.status);
        });
    } else {
      CompanyDashboardService.listAlerts(glbRegulationCode)
        .then((response) => {
          let count = parseFloat(response.headers["x-total-count"]);
          setTotalALerts(count);
          setAlerts([...response.data]);
        })
        .catch((error) => {
          //ErrorHandlingService.handleError(error.response.status);
        });
    }
  };

  // const handleViewAll = () => {
  //   navigate("/company_admin/alerts");
  //   if (profileId) {
  //     var encodedDat = Utils.encodeBase64(profileId);
  //     navigate("/company_admin/alerts/" + encodedDat);
  //   } else {
  //     navigate("/company_admin/alerts");
  //   }
  // };

  return (
    <div className="card SC-Alert-Card02">
      <div className="SC-Alert-Card02-head">
        <div className="SC-Alert-Card02-head_in">
          <strong>{t("Alerts.label")}</strong>
          {/* <span>03</span> */}
        </div>
       
      </div>
      <div className="SC-Alert-Card02-body">
        {alerts?.length > 0 ? (
          alerts?.map((item) => (
            <div
              className="Single_Alert_view02"
              onClick={() => handleClick(item)}
              key={item.id}
            >
              <div className="Icon_circleBox">
                {item.type === "ASSESSMENT_FORM_ACTION" ? (
                  <BsFileEarmark />
                ) : (
                  <BiUser />
                )}
              </div>
              <h6 className="m-0">
                {(() => {
                  switch (item.priority) {
                    case "HIGH":
                      return (
                        <Badge bg="badge-High">
                          {RISKSTATUS[item.priority]}
                        </Badge>
                      );
                    case "MEDIUM":
                      return (
                        <Badge bg="badge-Medium">
                          {RISKSTATUS[item.priority]}
                        </Badge>
                      );
                    case "LOW":
                      return (
                        <Badge bg="badge-Low">
                          {RISKSTATUS[item.priority]}
                        </Badge>
                      );
                    default:
                      return " ";
                  }
                })()}
                {item.message.length > 80
                  ? `(${item.message.substring(0, 80)}...`
                  : item.message}
              </h6>
              <p> {item.sourceCompany?.legalName}</p>
              <p className="date">
                {" "}
                {moment(item.createdDate).format("MMM DD, YYYY")}
              </p>
            </div>
          ))
        ) : (
          <p className="p-3 m-0">{t("NoAlertsAvailable.label")}</p>
        )}
        {totalAlerts > 10 && (
          <p className="text-end m-3">
            {" "}
            <Link to={`/company_admin/alerts/${encodedDat}`}>
              {t("ViewAll.label")}
            </Link>
            {/* <Link to="/company_admin/alerts">{t("ViewAll.label")}</Link> */}
            {/* <Link to="#" onClick={handleViewAll}>
              {t("ViewAll.label")}
            </Link> */}
          </p>
        )}
      </div>
      {
        modalDisplay 
        ?
          <TaskModal
            showModal={modalDisplay}
            id={0}
            modalData={{
              openedfor: "NEW",
              alertId: editAlert.id,
              description: editAlert.message,
              startDate: editAlert.createdDate
            }}
            isActionBased={true}
            onSaveCallBack={() => handleTaskSave()}
            onCloseCallback={() => { setModalDisplay(false); }}>
          </TaskModal>
        : <></>
      }
    </div>
  );
};
export default withTranslation()(AlertBox);
